/** localStorage draft for /smokerprofile — merged with other survey data on final submit. */
export const SMOKER_PROFILE_STORAGE_KEY = 'ploomsurvey:smokerProfile';

export type SmokerProfileAnswers = {
  race: string;
  state: string;
  brand: string;
  variant: string;
};

export function readSmokerProfileAnswers(): Partial<SmokerProfileAnswers> | null {
  try {
    const raw = localStorage.getItem(SMOKER_PROFILE_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const p = o as Record<string, unknown>;
    return {
      race: typeof p.race === 'string' ? p.race : '',
      state: typeof p.state === 'string' ? p.state : '',
      brand: typeof p.brand === 'string' ? p.brand : '',
      variant: typeof p.variant === 'string' ? p.variant : '',
    };
  } catch {
    return null;
  }
}

export function writeSmokerProfileAnswers(data: SmokerProfileAnswers): void {
  try {
    localStorage.setItem(SMOKER_PROFILE_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function clearSmokerProfileAnswers(): void {
  try {
    localStorage.removeItem(SMOKER_PROFILE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSmokerProfileComplete(): boolean {
  const s = readSmokerProfileAnswers();
  if (!s) return false;
  const { race, state, brand, variant } = s;
  return (
    typeof race === 'string' &&
    race.trim().length > 0 &&
    typeof state === 'string' &&
    state.trim().length > 0 &&
    typeof brand === 'string' &&
    brand.trim().length > 0 &&
    typeof variant === 'string' &&
    variant.trim().length > 0
  );
}
